<template>
  <div id="app">
    <b-button
      v-b-toggle.events-sidebar
      class="sidebar-button"
      variant="dark"
      size="md"
      @click="() => stop()"
    >
      <lottie
        class="lottie-container"
        :options="defaultOptions"
        :height="100"
        :width="80"
        @animCreated="handleAnimation"
      ></lottie>
    </b-button>
    <b-button
      v-b-toggle.story-sidebar
      class="sidebar-button-2"
      variant="dark"
      size="md"
      @click="() => stop()"
    >
      <img class="argo-image-small" src="./images/argo-sidebar-1.png"/>
    </b-button>

    <b-sidebar
      id="events-sidebar"
      title="Events"
      bg-variant="dark"
      text-variant="light"
      backdrop
    >
      <realtime-events v-if="hasMetamask"></realtime-events>
    </b-sidebar>
    <b-sidebar
      id="story-sidebar"
      v-model="showStorySideBar"
      bg-variant="dark"
      text-variant="light"
      backdrop
      no-header
    >
      <span class="story-sidebar-title">Hello, Hodling Friend!</span>
      <img class="argo-image-large" src="./images/argo-sidebar-1.png"/>
      <div class="story-sidebar-text-container">
        <p>I am Argo, your Zoombies Training Bot.</p>
        <p>I am always here to help you with your Zoombies World training.</p>
        <p>You can continue training or skip and restart another time.</p>
        <p>Simply click an option below.</p>
      </div>
      <button
        v-b-tooltip.hover
        class="story-sidebar-button story-sidebar-button-skip"
        title="This will instantly end your Zoombies Training" @click="skipStoryProgress"
      >
        End all training
      </button>
      <b-toast
        id="story-sidebar-toast-skip"
        toast-class="story-sidebar-toast-wrapper"
        body-class="story-sidebar-toast"
        :visible="showSkipToast"
        :auto-hide-delay="5000"
        :no-close-button="true"
        @hidden="showSkipToast=false"
      >
        Story skipped to end, click Argo for training options
      </b-toast>
      <button
        v-if="showResumeButton"
        v-b-tooltip.hover
        class="story-sidebar-button story-sidebar-button-resume"
        title="Continue training from where you left off" @click="resumeStoryProgress"
      >
      <b-toast
        id="story-sidebar-toast-resume"
        toast-class="story-sidebar-toast-wrapper"
        body-class="story-sidebar-toast"
        :visible="showResumeToast"
        :auto-hide-delay="3000"
        :no-close-button="true"
        @hidden="showResumeToast=false"
      >
        Story has been resumed now
      </b-toast>
        Resume Training
      </button>
      <button
        v-b-tooltip.hover
        class="story-sidebar-button story-sidebar-button-reset"
        title="Start your Zoombies training from the very beginning" @click="resetStoryProgress"
      >
      <b-toast
        id="story-sidebar-toast-restart"
        toast-class="story-sidebar-toast-wrapper"
        body-class="story-sidebar-toast"
        :visible="showResetToast"
        :auto-hide-delay="3000"
        :no-close-button="true"
        @hidden="showResetToast=false"
      >
        Story has been reset to beginning
      </b-toast>
        Restart Training 
      </button>
    </b-sidebar>
    <Header v-if="hasMetamask" />

    <b-modal id="no-web3-modal" hide-footer>
      <template #modal-title> Web3 Not Detected! </template>
      <div class="d-block text-center">
        <p class="no-web3-mobile-text">
          <a target="_blank" href="https://metamask.io/download.html"
            >Metamask</a
          >
          is required to connect to the Zoombies NFT World on the Moonbeam
          blockchain.
        </p>
        <p>
          Please install it from this link:
          <a target="_blank" href="https://metamask.io/download.html"
            >Metamask Downloads</a
          >
        </p>
      </div>
    </b-modal>
    <transition name="component-fade" mode="out-in">
      <router-view class="app-body" />
    </transition>
    <CzxpRewardEffect />
    <AppFooter />
    <transaction-modal />
  </div>
</template>

<script>
import { showSuccessToast } from "./util/showToast";
import Header from "./components/layout/Header.vue";
import AppFooter from "./components/layout/AppFooter";
import TransactionModal from "./components/TransactionModal.vue";
import { MessageBus } from "@/messageBus";
import CzxpRewardEffect from "./components/layout/CzxpRewardEffect";
import { BButton, BSidebar, BToast } from "bootstrap-vue";
import RealtimeEvents from "@/components/RealtimeEvents.vue";

import Lottie from "vue-lottie";
import animationData from "./assets/NotificationLottie.json";
import "./main.css";

import { mapGetters } from "vuex";
import { CURR_CHAIN } from "./util/constants/networks";

import Progress from './components/Progress.js';
import { Progression } from './components/Progression.js'

export default {
  name: "App",
  components: {
    Header,
    AppFooter,
    TransactionModal,
    CzxpRewardEffect,
    Lottie,
    BButton,
    BSidebar,
    BToast,
    RealtimeEvents,
  },
  data() {
    return {
      defaultOptions: {
        animationData: animationData,
        loop: true,
        autoplay: false,
      },
      Progression,
      stepIndex: 1,
      showStorySideBar: false,
      showSkipToast: false,
      showResumeToast: false,
      showResetToast: false,
      showResumeButton : false,
    };
  },
  async created() {
    this.ProgressInstance = new Progress();

    // reset
    // this.ProgressInstance.resetProgress();
    // this.ProgressInstance.updateProgress({name: 'body', value: 6});

    const progress = this.ProgressInstance.getProgress();

    if (progress.hasOwnProperty('body')) {
      this.stepIndex = progress.body;
    } else {
      this.stepIndex = 1;
    }

    this.ProgressInstance.updateProgress({name: 'body', value: this.stepIndex});
    Progression.stepIndex = this.stepIndex;

    MessageBus.$on("connect", () => {
      this.$store.dispatch("blockChain/initBlockchain", {
        CURR_CHAIN: CURR_CHAIN,
        noMetamaskCallback: () => {
          this.$bvModal.show("no-web3-modal");
        },
      });
    });
  },
  computed: {
    events() {
      return this.$store.state.events.events;
    },
    hasMetamask() {
      return !!window.ethereum;
    },
    ...mapGetters({
      getWalletAddress: "blockChain/getWalletAddress",
    }),
  },
  watch: {
    '$route'(to, from) {
      this.showResumeButton = (this.ProgressInstance.isPathComplete(to.name) == false);
    },
    getWalletAddress(val, oldVal) {
      if (val && oldVal && val !== oldVal) {
        showSuccessToast(this, "Successfully changed wallets.");
      }
    },
    events(val, oldVal) {
      if (val.length > oldVal.length) {
        this.play();
      } else {
        this.stop();
      }
    },
  },
  beforeCreate() {
    if (window.ethereum) {
      this.$store.dispatch("blockChain/initBlockchain", {
        CURR_CHAIN: CURR_CHAIN,
        noMetamaskCallback: () => {
          this.$bvModal.show("no-web3-modal");
        },
      });
    } else {
      // Setup listener for mobile
      window.addEventListener(
        "ethereum#initialized",
        () => {
          this.$store.dispatch("blockChain/initBlockchain", {
            CURR_CHAIN: CURR_CHAIN,
            noMetamaskCallback: () => {
              this.$bvModal.show("no-web3-modal");
            },
          });
        },
        {
          once: true,
        }
      );
    }
  },
  async mounted() {
    // Twitter library - footer follow button uses it
    window.twttr = (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0],
        t = window.twttr || {};
      if (d.getElementById(id)) return t;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);

      t._e = [];
      t.ready = function (f) {
        t._e.push(f);
      };

      return t;
    })(document, "script", "twitter-wjs");
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },
    play: function () {
      this.anim.play();
    },
    stop: function () {
      this.showResumeButton = this.ProgressInstance.isPathComplete(this.$route.matched[0].components.default.name) == false;
      this.anim.stop();
    },
    skipStoryProgress() {
      this.showSkipToast = true;
      this.showResumeButton = false;

      //Progression.stepIndex = 99;
      //Progression.storyIndex = 99;
      this.ProgressInstance.updateProgress({name: 'bodyCompleted', value: true});
      this.ProgressInstance.updateProgress({name: 'shopCompleted', value: true});
      this.ProgressInstance.updateProgress({name: 'myZoombiesNftsCompleted', value: true});
      this.ProgressInstance.updateProgress({name: 'valuationCompleted', value: true});
      this.ProgressInstance.updateProgress({name: 'cardSetsCompleted', value: true});
      this.ProgressInstance.updateProgress({name: 'affiliatesCompleted', value: true});
      this.showStorySideBar = false;
    },
    resumeStoryProgress() {
      this.showResumeToast = true;

      this.showStorySideBar = false;
      this.$bvModal.show('story-modal');
    },
    resetStoryProgress() {
      this.showResetToast = true;
      this.showResumeButton = true;

      this.ProgressInstance.resetProgress();

      Progression.stepIndex = 1;
      Progression.storyIndex = 0;

      this.showStorySideBar = false;
      this.$bvModal.show('story-modal');
      Progression.typingSound.currentTime = 83;
      Progression.typingSound.play();
      Progression.popOverSound.play();
    }
  },
};
</script>

<style lang="scss">
#app {
  height: 100vh;
  overflow-x: hidden;
  background-image: url("components/assets/home_bg.webp");
  background-size: cover;
  position: relative;
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
  }
}

/* unvisited link */
a:link {
  color: #ffa7c4;
}

/* visited link */
a:visited {
  color: #ffa7c4;
}

/* mouse over link */
a:hover {
  color: #82ffd6;
}

/* selected link */
a:active {
  color: #82ffd6;
}

.modal-content {
  background-color: transparent;
}

.app-body {
  padding: 10px 30px;
  color: white;
  max-width: 1600px;
  width: 95%;
  margin: 0 auto;

  @media (max-width: 800px) {
    padding: 10px 10px;
  }

  a.dropdown-item {
    color: black;

    &.active {
      background: #7ef4f6;
    }
  }
}
.tooltip {
  top: -10px;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.toast-wrapper {
  display: flex;
  align-items: center;
}
.toast-message {
  margin-left: 10px;
  font-size: 20px;
}
.web3modal-modal-card {
  margin-top: 150px;
}
/* BINANCE color #F0B90B */
a {
  padding: 2px;
  color: #f0b90b;
}

.story-sidebar-title {
  margin-top: 10px;
  margin-bottom: 15px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  font-family: "Truculenta", sans-serif;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

.argo-image-large {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 70%;
}

.argo-image-small {
  position: absolute;
  top: 38px;
  left: 2px;
  width: 90%;
}

.sidebar-button {
  height: 110px;
  width: 40px;
  top: 40%;
  position: fixed;
  background-color: darkgray;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  z-index: 1000;
}

.sidebar-button-2 {
  height: 110px;
  width: 40px;
  top: 55%;
  position: fixed;
  background-color: darkgray;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  z-index: 1000;
}

.story-sidebar-button {
  margin-top: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 70%;
  height: 45px;
  font-family: "Truculenta", sans-serif;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  border: 2px solid #00D1FF;
  border-radius: 15px;
}

.story-sidebar-button-skip {
  background-color : #1E162F;
}

.story-sidebar-button-resume {
  background-color : #012e1a;
}

.story-sidebar-button-reset {
  background-color : #460000;
}

.story-sidebar-button:hover {
  width: 75%;
  font-size: 18px;
  box-shadow: 15px 15px 15px rgba(0, 0, 0, 0.4);
}

.story-sidebar-text-container {
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  font-family: "Truculenta", sans-serif;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
}

.lottie-container {
  position: absolute;
  top: 0;
  left: -22px;
}

.no-web3-mobile-text {
  font-size: 10px;
  font-weight: bold;
  color: white;
  text-align: center;
  margin-top: 20px;
}
</style>
